import { Routes } from "@angular/router";
import { authGuard } from "./guards/auth.guard";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./kudoshub-home/kudoshub-home.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "who-we-are",
    loadChildren: () =>
      import("./who-we-are/who-we-are.routes").then((m) => m.routes),
  },
  {
    path: "why-kudoshub",
    loadChildren: () =>
      import("./why-kudoshub/why-kudoshub.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "email-validation",
    loadChildren: () =>
      import(
        "./kudoshub-services/email-list-cleaning/email-list-cleaning.routes"
      ).then((m) => m.routes),
  },
  {
    path: "email-list-validation-and-verification",
    redirectTo: "/email-validation",
  },
  {
    path: "email-marketing",
    loadChildren: () =>
      import("./kudoshub-services/email-marketing/email-marketing.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "mobile-app-development",
    loadChildren: () =>
      import(
        "./kudoshub-services/mobile-app-development/mobile-app-development.routes"
      ).then((m) => m.routes),
  },
  {
    path: "web-development",
    loadChildren: () =>
      import("./kudoshub-services/web-development/web-development.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "email-validation-api",
    loadChildren: () =>
      import("./emailvalidation/emailvalidation.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "email-list-validation-and-verification-api",
    redirectTo: "/email-validation-api",
  },
  {
    path: "what-we-do",
    loadChildren: () =>
      import("./what-we-do/what-we-do.routes").then((m) => m.routes),
  },

  {
    path: "offers",
    loadChildren: () =>
      import("./offers/offers.routes").then((m) => m.routes),
  },

  {
    path: "career-with-us",
    loadChildren: () =>
      import("./career-with-us/career-with-us.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "get-in-touch",
    loadChildren: () =>
      import("./get-in-touch/get-in-touch.routes").then(
        (m) => m.routes
      ),
  },
  {
    path: "our-policies",
    loadChildren: () =>
      import("./our-policies/our-policies.routes").then(
        (m) => m.routes
      ),
  },

  {
    path: 'zerobounce-alternative',
    loadChildren: () =>
      import('./kudoshub-vs-zerobounce/kudoshub-vs-zerobounce.routes').then(
        (m) => m.routes
      )
  },
  {
    path: "neverbounce-alternative",
    loadChildren: () =>
      import("./kudoshub-vs-neverbounce/kudoshub-vs-neverbounce.routes").then(
        (m) => m.routes
      ),
  },

  // Already commented out code-
  // {
  //   path: "briteverify-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-briteverify/kudoshub-vs-briteverify.module").then(
  //       (m) => m.KudoshubVsBriteverifyModule
  //     ),
  // },

  // {
  //   path: "debounce-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-debounce/kudoshub-vs-debounce.module").then(
  //       (m) => m.KudoshubVsDebounceModule
  //     ),
  // },

  // {
  //   path: "cleanify-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-cleanify/kudoshub-vs-cleanify.module").then(
  //       (m) => m.KudoshubVsCleanifyModule
  //     ),
  // },

  // /*{
  //   path: "email-validator-alternative",
  //   loadChildren: () =>
  //     import(
  //       "./kudoshub-vs-email-validator/kudoshub-vs-email-validator.module"
  //     ).then((m) => m.KudoshubVsEmailValidatorModule),
  // },*/

  // // {
  // //   path: "blazeverify-alternative",
  // //   loadChildren: () =>
  // //     import("./kudoshub-vs-blazeverify/kudoshub-vs-blazeverify.module").then(
  // //       (m) => m.KudoshubVsBlazeverifyModule
  // //     ),
  // // },

  // {
  //   path: "kickbox-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-kickbox/kudoshub-vs-kickbox.module").then(
  //       (m) => m.KudoshubVsKickboxModule
  //     ),
  // },

  // {
  //   path: "impressionwise-alternative",
  //   loadChildren: () =>
  //     import(
  //       "./kudoshub-vs-impressionwise/kudoshub-vs-impressionwise.module"
  //     ).then((m) => m.KudoshubVsImpressionwiseModule),
  // },

  // {
  //   path: "emaillistverify-alternative",
  //   loadChildren: () =>
  //     import(
  //       "./kudoshub-vs-emaillistverify/kudoshub-vs-emaillistverify.module"
  //     ).then((m) => m.KudoshubVsEmaillistverifyModule),
  // },

  // {
  //   path: "xverify-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-xverify/kudoshub-vs-xverify.module").then(
  //       (m) => m.KudoshubVsXverifyModule
  //     ),
  // },

  // {
  //   path: "webbula-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-webbula/kudoshub-vs-webbula.module").then(
  //       (m) => m.KudoshubVsWebbulaModule
  //     ),
  // },

  // {
  //   path: "clearout-alternative",
  //   loadChildren: () =>
  //     import("./kudoshub-vs-clearout/kudoshub-vs-clearout.module").then(
  //       (m) => m.KudoshubVsClearoutModule
  //     ),
  // },

  {
    path: "kudoshub-vs-zerobounce",
    redirectTo: "/zerobounce-alternative",
  },

  {
    path: "kudoshub-vs-neverbounce",
    redirectTo: "/neverbounce-alternative",
  },

  // {
  //   path: "kudoshub-vs-briteverify",
  //   redirectTo: "/briteverify-alternative",
  // },

  // {
  //   path: "kudoshub-vs-debounce",
  //   redirectTo: "/debounce-alternative",
  // },

  // {
  //   path: "kudoshub-vs-cleanify",
  //   redirectTo: "/cleanify-alternative",
  // },

  /* {
     path: "kudoshub-vs-email-validator",
     redirectTo: "/email-validator-alternative",
   },*/

  // {
  //   path: "kudoshub-vs-blazeverify",
  //   redirectTo: "/blazeverify-alternative",
  // },

  // {
  //   path: "kudoshub-vs-kickbox",
  //   redirectTo: "/kickbox-alternative",
  // },

  // {
  //   path: "kudoshub-vs-impressionwise",
  //   redirectTo: "/impressionwise-alternative",
  // },

  // {
  //   path: "kudoshub-vs-emaillistverify",
  //   redirectTo: "/emaillistverify-alternative",
  // },

  // {
  //   path: "kudoshub-vs-xverify",
  //   redirectTo: "/xverify-alternative",
  // },

  // {
  //   path: "kudoshub-vs-webbula",
  //   redirectTo: "/webbula-alternative",
  // },

  // Already commented code end--

  {
    path: "login",
    loadChildren: () =>
      import("./public-login/public-login.routes").then(
        (m) => m.routes
      ),
    data: { disablePopup: true }
  },

  {
    path: "register",
    loadChildren: () =>
      import("./public-signup/public-signup.routes").then(
        (m) => m.routes
      ),
    data: { disablePopup: true }
  },

  {
    path: "integrations",
    loadChildren: () => import('./integration/integration.routes').then(m => m.routes),
  },

  {
    path: "docs",
    loadChildren: () =>
      import("./documentation/documentation.routes").then(
        (m) => m.routes
      ),
  },

  {
    path: "sitemap",
    loadChildren: () => import("./sitemap/sitemap.routes").then((m) => m.routes),
  },

  // Temporarily closed---------
  // {
  //   path: "free-email-verifier",
  //   loadChildren: () => import('./free-email-verifier/free-email-verifier.routes').then(m => m.routes),
  // },
  // {
  //   path: "email-checker",
  //   loadChildren: () => import('./email-checker/email-checker.routes').then(m => m.routes),
  // },
  // {
  //   path: "bulk-email-verify",
  //   loadChildren: () => import('./bulk-email-verify/bulk-email-verify.routes').then(m => m.routes),
  // },

  {
    path: "invoice/:id",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./invoice-public/invoice-public.routes").then(
        (m) => m.routes
      ),
  },

  {
    path: "register/chat/invites/:token",
    loadChildren: () =>
      import("./public-signup/public-signup.routes").then(
        (m) => m.routes
      ),
      data: { disablePopup: true }
  },
  {
    path: "404",
    loadChildren: () =>
      import("./not-found/not-found.routes").then((m) => m.routes),
  },
  { path: "**", redirectTo: "/404" },
];